import React from 'react';
import { SvgIcon } from 'app/features/Icons/components';

const RecStopIcon: React.FC = () => (
    <SvgIcon width="24" height="24" viewBox="0 0 24 24">
        <path
            d="M24 12C24 18.6276 18.6276 24 12 24C5.3724 24 0 18.6276 0 12C0 5.3724 5.3724 0 12 0C18.6276 0 24 5.3724 24 12ZM7.8 6.6C7.48174 6.6 7.17652 6.72643 6.95147 6.95147C6.72643 7.17652 6.6 7.48174 6.6 7.8V16.2C6.6 16.5183 6.72643 16.8235 6.95147 17.0485C7.17652 17.2736 7.48174 17.4 7.8 17.4H16.2C16.5183 17.4 16.8235 17.2736 17.0485 17.0485C17.2736 16.8235 17.4 16.5183 17.4 16.2V7.8C17.4 7.48174 17.2736 7.17652 17.0485 6.95147C16.8235 6.72643 16.5183 6.6 16.2 6.6H7.8Z"
            fill="currentColor"
        />
    </SvgIcon>
);

export default RecStopIcon;
